import React from 'react';
import {
  useCurrentClientQuery,
  usePoolQuery,
  useUpdateSalesforceSettingMutation,
} from 'api';

const Priority = () => {
  const {data: {currentClient: {salesforceSetting = {}} = {}} = {}} =
    useCurrentClientQuery();
  const {data: {pool: {salesforceTaskPriorities = []} = {}} = {}} =
    usePoolQuery();
  const [updateSalesforceSettingMutation] =
    useUpdateSalesforceSettingMutation();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    updateSalesforceSettingMutation({
      variables: {
        attributes: {
          scoreSalesforceTaskPriorityId: e.target.value,
        },
      },
    });
  };

  return (
    <div className="flex items-center text-gray-700">
      <label htmlFor="priority" className="w-24 mr-5 font-bold">
        優先度
      </label>
      <select
        name="priority"
        value={salesforceSetting.scoreSalesforceTaskPriorityId || ''}
        onChange={handleChange}
        className="w-36 block form-select appearance-none bg-white border-gray-100 p-2 rounded-sm focus:outline-none text-sm text-gray-800">
        <option value="">選択してください</option>
        {salesforceTaskPriorities.map((priority) => (
          <option key={priority.id} value={priority.id}>
            {priority.masterLabel}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Priority;
